

export function formatIndianCurrency(number) {
    number= Number(number)
    if (typeof number !== 'number') {
        throw new Error('Input must be a number');
    }
    
    let numStr = number.toString();
    let afterPoint = "";
    if (numStr.indexOf(".") > 0) {
        afterPoint = numStr.substring(numStr.indexOf("."));
        numStr = numStr.split(".")[0];
    }

    const lastThree = numStr.substring(numStr.length - 3); 
    const otherNumbers = numStr.substring(0, numStr.length - 3);

    if (otherNumbers !== "") {
        numStr = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    } else {
        numStr = lastThree;
    }
    return numStr + afterPoint;
}




export function getTotalGross(val) {
  const allowanceAmount = val?.allowance?.reduce((sum, allowance) => 
    allowance?.add_to_gross ? sum + Number(allowance?.allowance_value || 0) : sum, 0);
  const restEarnings = 
    Number(val?.payable_basic_salary || 0) + 
    Number(val?.ot_amount || 0);
  const total = allowanceAmount + restEarnings;
  return total;
}
export function getTotalearn(val){
  const grossAmount = getTotalGross(val);
  const allowanceammount =  val?.allowance?.reduce((sum, allowance) => !allowance?.add_to_gross ? sum + Number(allowance?.allowance_value || 0) : sum, 0);
  const restEarnings = 
    Number(val?.bonus_amount) + 
    Number(val?.incentive_amount) + 
    Number(val?.gross_arrear) + 
    Number(val?.any_other_amt);
  const total =grossAmount+allowanceammount+restEarnings;
  return total
  
  }


export function calculateTotalDeduction(useInfo) {
    return (
      Number(useInfo?.epf_amount || 0) +
      Number(useInfo?.esi_amount || 0) +
      Number(useInfo?.pTaxAmount || 0) +
      Number(useInfo?.labour_welfare || 0) +
      Number(useInfo?.canteen || 0) +
      Number(useInfo?.tds || 0) +
      Number(useInfo?.advance_amount || 0) +
      Number(useInfo?.loan_advance || 0) +
      Number(useInfo?.epf_arrear || 0) +
      Number(useInfo?.esic_arrear || 0) +
      Number(useInfo?.any_other_deduction || 0)
    );
  }




  export function convertMinutesToHours(minutes) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours} hr ${remainingMinutes} min`;
}